module.exports = __webpack_public_path__ + "static/media/favicon.3af2b463.ico";